import React, {Fragment} from "react";

import './ExistingChildTable.scss' ;
import IconTooltip from "ui/Tooltip/IconTooltip";

const ExistingChildTable = ( {data, onChildClick} ) =>
{
    const actionStyle = {
        justifySelf: 'center'
    }
    const actionIcon = (child) =>
    {
        if ( !isLAC(child))
        {
            return <IconTooltip disabled={false} placement='top' onClick={() => onChildClick (child.child_id)} text='Reinstate this pupil' icon='glyphicon-cloud-download' color='var(--s360-icon-blue)' />
        }
        else
        {
            return null ;
        }
    }

    const isLAC = (child) =>
    {
        return +(child.lac_status) === 1 ;
    }

    const dataRows = () =>
    {
        return data.map ((child) =>
        {
            const name = child.firstname + ' ' + child.surname ;

            const status = isLAC(child) ? "Already In Care" : "Removed from LAC"
            const statusStyle = isLAC(child) ? {} : {color: 'var(--s360-icon-green'}

            return <div key={'cr' + child.child_id} className='existing-child-row'>
                <div key='r1'>{child.child_upn}</div>
                <div key='r2'>{name}</div>
                <div key='r3'>{child.date_of_birth}</div>
                <div key='r4' style={statusStyle}>{status}</div>
                <div key='r5' style={actionStyle}>{actionIcon(child)}</div>
            </div>
        })
    }

    return (
        <Fragment>
            <div key='h1' className='existing-child-row header'>
            <div key='r1'>UPN</div>
            <div key='r2'>Pupil Name</div>
            <div key='r3'>Date of Birth</div>
            <div key='r4'>LAC Status</div>
            <div key='r5'>Action</div>
             </div>
            { dataRows() }
        </Fragment>
    )
}

export default ExistingChildTable ;